import { type SelectDataObject } from '../_tools/inputfields/Select';

const sAkte: SelectDataObject<{ i: number; cat: string; printIds?: number[] }>[] = [
    { i: 1, t: 'Vorkalkulation', cat: 'K' },
    { i: 2, t: 'Preisfinder', cat: 'K' },
    { i: 3, t: 'RG Instandsetzung Aufbereitung', cat: 'K' },
    { i: 4, t: 'Zusatzdokument (Kosten)', cat: 'K' },
    { i: 5, t: 'Ankaufvertrag', cat: 'A' },
    { i: 6, t: 'Eingangsrechnung', cat: 'A' },
    { i: 7, t: 'Hereinnahmeprotokoll', cat: 'A' },
    { i: 8, t: 'Zusatzdokument (Ankauf)', cat: 'A' },
    { i: 10, t: 'GW-Bewertung', cat: 'W' },
    { i: 11, t: 'Protokoll GW-Bewertung', cat: 'W', printIds: [1535] },
    { i: 12, t: 'Gutachten Unfall', cat: 'W_UnfallGutachten' },
    { i: 13, t: 'Gutachten Leasing', cat: 'W' },
    { i: 14, t: 'Reparaturhistorie', cat: 'W' },
    { i: 15, t: 'Zusatzdokument (Werkstatt)', cat: 'W' },
    { i: 16, t: 'Zulassung Teil I (Vorbesitzer)', cat: 'P' },
    { i: 17, t: 'Zulassung Teil II (Vorbesitzer)', cat: 'P' },
    { i: 18, t: 'HU-Bescheinigung', cat: 'P' },
    { i: 19, t: 'COC-Bescheinigung', cat: 'P' },
    { i: 20, t: 'GW-Siegel', cat: 'P' },
    { i: 21, t: 'ABE Sonderzubehör', cat: 'P' },
    { i: 22, t: 'Reifenlagerungsbeleg', cat: 'P' },
    { i: 23, t: 'Serviceplan', cat: 'P' },
    { i: 24, t: 'Zusatzdokument (Papiere)', cat: 'P' },
    { i: 25, t: 'Historie', cat: 'B' },
    { i: 26, t: 'Fahrzeugdaten', cat: 'B' },
    { i: 27, t: 'Preisanpassungen', cat: 'B' },
    { i: 28, t: 'Webposition', cat: 'B' },
    { i: 29, t: 'Anfragen', cat: 'B' },
    { i: 30, t: 'Angebote', cat: 'B' },
    { i: 31, t: 'Zusatzdokument (Bestand)', cat: 'B' },
    { i: 32, t: 'Verbindliche Bestellung', cat: 'V', printIds: [1557, 1558, 1560] },
    { i: 33, t: 'Finanzierungs- / Leasingunterlagen', cat: 'V' },
    { i: 34, t: 'GW-Garantieantrag', cat: 'V' },
    { i: 35, t: 'Rechnungsaufbereitung', cat: 'V' },
    { i: 36, t: 'Übergabeprotokoll (Käufer)', cat: 'V' },
    { i: 37, t: 'Fahrzeugrechnung (Verkauf)', cat: 'V', printIds: [1526] },
    { i: 38, t: 'Zulassung Teil I (Käufer)', cat: 'V' },
    { i: 39, t: 'Zulassung Teil II (Käufer)', cat: 'V' },
    { i: 40, t: 'Zusatzdokument (Verkauf)', cat: 'V' },
    { i: 41, t: 'Fzg.-Angebot', cat: 'A' },
    { i: 42, t: 'Gutschriften', cat: 'A' },
    { i: 43, t: 'Interne Rechnung', cat: 'B' },
    { i: 44, t: 'Checkliste (Final)', cat: 'V' },
    { i: 45, t: 'Personalausweis (Käufer)', cat: 'V' },
    { i: 46, t: 'Führerschein (Käufer)', cat: 'V' },
    { i: 47, t: 'Provisionsblatt', cat: 'V' },
    { i: 48, t: 'Offene Posten', cat: 'V' },
    { i: 49, t: 'Anschreiben Zulassungsstelle', cat: 'V' },
    { i: 50, t: 'Dispo-Blatt', cat: 'V' },
    { i: 51, t: 'Sonstiges', cat: 'S' },
    { i: 52, t: 'Probefahrten', cat: 'B' },
    { i: 53, t: 'Zahlungsplan', cat: 'V', printIds: [1534] },
    { i: 54, t: 'Gutachten DEKRA', cat: 'W' },
    { i: 55, t: 'Batterie-Zertifikat', cat: 'P' },
];
export default sAkte;
